import React, { Component } from 'react';
import 'styled-components/macro';
import * as types from 'styled-components/cssprop'; /* eslint-disable-line */
import { css, withTheme, Theme } from 'styled-components';
import { SuccessICON, FailICON, WarningICON, WarningFetchICON } from './svg';
import Loadding from '../Loading';
import { isMobile } from '@/utils/constants';

class VerifyMessage extends Component<{
  loading: boolean;
  status: 'pass' | 'fail' | 'init' | 'going' | 'error';
  verify_result_msg: string;
  theme: Theme;
  isFetch: boolean;
  challenge_mode?: 'whirl' | 'slide' | 'text' | '3d' | '';
  lang?: String;
  isTooFrequently?: boolean;
}> {
  render() {
    const {
      status,
      loading,
      verify_result_msg,
      theme,
      isFetch,
      challenge_mode,
      lang,
      isTooFrequently,
    } = this.props;
    let icon = null;
    let iconElem;
    let size = isFetch ? 24 : 28;
    let fontSize = 14;
    if (challenge_mode === 'whirl') {
      if (isMobile) {
        size = 24;
      } else {
        size = isFetch ? 24 : 32;
      }
      if (lang) {
        if (!lang.startsWith('zh')) {
          fontSize = 13;
        } else {
          fontSize = 17;
        }
      }
    }
    if (loading) {
      iconElem = (
        <Loadding
          className="icon loading"
          icon={theme.imgLoadingIcon}
          size={size}
        />
      );
    } else {
      switch (status) {
        case 'pass':
          icon = <SuccessICON color={theme.verifyIconColor} />;
          break;
        case 'fail':
          icon = <FailICON color={theme.verifyIconColor} />;
          break;
        case 'error':
          icon = isFetch ? (
            <WarningFetchICON color={theme.imgLoadingErrorIconColor} />
          ) : (
            <WarningICON color={theme.verifyIconColor} />
          );
          break;
        default:
          icon = isFetch ? (
            <WarningFetchICON color={theme.imgLoadingErrorIconColor} />
          ) : (
            <WarningICON color={theme.verifyIconColor} />
          );
          break;
      }
      iconElem = (
        <div
          className="icon"
          css={css`
            margin: 0 auto;
            width: ${size / 100}em;
            height: ${size / 100}em;
            svg {
              display: block;
              width: 100%;
              height: 100%;
              overflow: visible;
            }
          `}
        >
          {icon}
        </div>
      );
    }
    const isWhirlTooFrequently = isTooFrequently && challenge_mode === 'whirl';
    return (
      <div
        className={`captcha_verify_message captcha_verify_message-${status}`}
        css={css`
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 999999;
          background-color: ${challenge_mode === 'whirl' && !isFetch
            ? theme.whirlMaskBgc
            : isFetch
            ? theme.imgLoadingBgColor
            : theme.verifyMsgBgColor};
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        `}
        style={
          challenge_mode === 'whirl'
            ? {
                height: `${isMobile ? 1.72 : 2.12}em`,
                width: `${isMobile ? 1.72 : 2.12}em`,
                borderRadius: '50%',
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                WebkitTransform: 'translate(-50%, -50%)',
                msTransform: 'translate(-50%, -50%)',
              }
            : {}
        }
      >
        {!isWhirlTooFrequently && iconElem}
        <div
          className="msg"
          // 环形频繁验证一定是白色
          css={css`
            padding: ${challenge_mode === 'whirl' ? '0.1em 0.12em' : '0.1em'};
            color: ${isFetch
              ? theme.imgLoadingTextColor
              : theme.verifyMsgColor};
            display: ${verify_result_msg ? 'inline-block' : 'none'};
            text-align: center;
            max-width: 2em;
          `}
        >
          <div
            css={css`
              font-size: ${fontSize / 100}em !important;
            `}
          >
            {verify_result_msg}
          </div>
        </div>
      </div>
    );
  }
}

export default withTheme(VerifyMessage);
